import React from "react";
import { Field, FormikTouched } from "formik";

interface Props {
  value: string;
  name: any;
  placeholder: string;
  type: any;
  onChange: (e: any) => void;
  label: any;
  errors: any;
  touched: FormikTouched<any>;
}
const LabelInsideTextArea = (props: Props) => {
  return (
    <div>
      {props.label !== null ? (
        <>
          <label htmlFor="">{props.label}</label>
        </>
      ) : null}
      <div
        className={
          props.errors && props.errors[props.name] && props.touched[props.name]
            ? "label-inside-input-text-area-error input-container-wrapper"
            : "label-inside-input-text-area input-container-wrapper"
        }
      >
        {/* <div className="label-inside-input-label-text-area">{props.label}</div> */}
        <Field
          component="textarea"
          name={props.name}
          className="input-control text-area-control"
          placeholder={props.label}
        ></Field>

        <div className="error-line">
          {props.errors &&
          props.errors[props.name] &&
          props.touched[props.name] ? (
            <span>{props.errors[props.name]}</span>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default LabelInsideTextArea;
